<h3>What is the Carbon-Score?</h3>
<p>
  The Carbon-Score is a logo that informs you about the carbon footprint of a recipe. It is based on a 5-level scale, from lowest impact A (<=80g CO2/100g) to
  highest impact E (>530g CO2/100g).
</p>

<div class="carbonscore">
  <ion-icon class="carbonscore-picto" src="/assets/svg/dish/carbon-score/carbon-score-A.svg"></ion-icon>
  <ion-icon class="carbonscore-picto" src="/assets/svg/dish/carbon-score/carbon-score-B.svg"></ion-icon>
  <ion-icon class="carbonscore-picto" src="/assets/svg/dish/carbon-score/carbon-score-C.svg"></ion-icon>
  <ion-icon class="carbonscore-picto" src="/assets/svg/dish/carbon-score/carbon-score-D.svg"></ion-icon>
  <ion-icon class="carbonscore-picto" src="/assets/svg/dish/carbon-score/carbon-score-E.svg"></ion-icon>
</div>

<h3>How is the Carbon-Score calculated?</h3>
<p>
  Independent experts in carbon strategy have assigned a robust emission factor to each ingredient in our recipes based on France scientific databases. These
  emission factors are then refined according to the criteria of seasonality, production method (organic, labels, etc.), conservation and average distance from
  supplies.<br />
  They are then aggregated in proportion to the recipe to obtain the carbon impact of the recipe, expressed per 100g.
</p>

<h3>What is the purpose of the Carbon-Score?</h3>
<ul>
  <li>- Offer real transparency on the carbon footprint of our recipe</li>
  <li>- Raising awareness of sustainable foo</li>
</ul>
<h3>And concretely, what does it change for you?</h3>
<p>The Carbon-Score makes it easy to compare the carbon footprint of our recipes in order to make informed choices about sustainable food.</p>
<footer>
  <p>THE CHOICE TO EAT WELL ON A DAILY BASIS WHILE REDUCING ITS ENVIRONMENTAL IMPACT!</p>
</footer>
